export default __webpack_public_path__ + "static/14-58f22b1e2b497f5bb358c55b83ed39ad.webp";